import React from 'react';
import { starRatingGrey, starRatingWhite } from '../../paths/defaultImage';
import LazyImage from './lazyLoad';

export default function starRating({ rating, customStyle }) {
  const getColor = (ratings) => {
    if (ratings >= 3 && ratings <= 5) {
      return '#31C16D';
    } else if (ratings >= 0 && ratings < 3) {
      return '#FFCE00';
    }
    return '';
  };
  const inputStyle = {
    backgroundColor: rating == '--' ? 'white' : getColor(rating),
  };
  return (
    <div
      className={`d-flex justify-content-between align-items-center star-rating gap-1
      ${rating != '--' ? 'white-color' : ''} ${customStyle}`}
      style={inputStyle}>
      {rating == '--' ? (
        <LazyImage src={starRatingGrey} alt='GreyStar' width='38px' height='20px' />
      ) : (
        <LazyImage src={starRatingWhite} alt='WhiteStar' width='12px' height='11px' />
      )}

      {rating != '--' && <div className='fs-10 fw-600'>{rating.toFixed(1)}</div>}
    </div>
  );
}
